import { trans, getResourcePath, useSoyuzData } from '@spotahome/soyuz/client';

import {
  Section,
  ThemeProvider,
  CookiesProvider,
  ToastContainer,
  FooterSimplified,
  UserInfoProvider,
  AppBanner
} from '@spotahome/ui-library';

// Styles
import '@spotahome/landings-common/src/scss/init.scss';

import LazyLoginSignUpModal from '@spotahome/landings-common/src/components/LoginSignupModal';
import Hero from '@spotahome/landings-common/src/components/Hero';
import HeaderContainer from '@spotahome/landings-common/src/components/HeaderContainer';
import Apply from '@spotahome/landings-common/src/components/Apply';

import WhyJoin from './components/WhyJoin';
import HowItWorks from './components/HowItWorks';
import LookingForyou from './components/LookingForYou';

// Styles
import './main.scss';

const CALL_TO_ACTION_URL = 'https://201821.typeform.com/to/gwAlbO';

const AmbassadorContainer = () => {
  const { [AmbassadorContainer.NAME]: requestedData } = useSoyuzData();
  const { deviceType, initialCookie } = requestedData;

  return (
    <CookiesProvider initialCookie={initialCookie}>
      <ThemeProvider flags={{ newButtons: true }}>
        <UserInfoProvider>
          <ToastContainer />
          <AppBanner source="home" deviceType={deviceType} />g
          <Hero
            menu={<HeaderContainer tracking="ga-ambassadors" />}
            title={trans('ambassador.alt.hero.title')}
            subtitle={trans('ambassador.alt.hero.subtitle')}
            backgroundImage={`url(${getResourcePath(
              '/images/ambassador/ambassador-header.jpg'
            )})`}
            callToActionText="hero.apply-now"
            callToActionPath={CALL_TO_ACTION_URL}
          />
          <Section background="light" className="ambassador__looking-for-you">
            <LookingForyou />
          </Section>
          <Section background="light" className="ambassador__hiw">
            <HowItWorks />
          </Section>
          <Section background="light" className="ambassador__why-join">
            <WhyJoin />
          </Section>
          <Section background="dark">
            <Apply
              actionUrl={CALL_TO_ACTION_URL}
              headingText={trans('ambassador.apply.title')}
              descriptionText={trans('ambassador.apply.description')}
            />
          </Section>
          <LazyLoginSignUpModal />
          <FooterSimplified />
        </UserInfoProvider>
      </ThemeProvider>
    </CookiesProvider>
  );
};

AmbassadorContainer.NAME = 'AmbassadorContainer';

AmbassadorContainer.requestData = req => ({
  data: {
    deviceType: req.device.type,
    initialCookie: req.headers.cookie
  }
});

export default AmbassadorContainer;
